<section class="contact">
  <div class="bg-form">
    <div class="container">
      <h2 class="text-center">Контакты</h2>
      <p class="text-center">Для связи с нами используйте один из каналов</p>
      <div class="info-block-contact animatedParent">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12 animated bounceInLeft">
            <div class="inside left">
              <div class="images"><img src="assets/images/phone-light.png" alt="phone"></div>
              <h4>Возникли вопросы? Позвоните</h4>
              <a href="tel:220-961">220-961</a><br>
              <a href="tel:8(4712)76-02-03">8(4712)76-02-03</a>
            </div><!--inside-->
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 animated bounceInRight">
            <div class="inside right">
              <div class="images"><img src="assets/images/mail-light.svg" alt="mail"></div>
              <h4>Электронная почта</h4>
              <a href="http://mailto:support@octopus-online.ru">Служба поддержики: support@octopus-online.ru</a>
              <a href="http://mailto:request@octopus-online.ru">Заявка на подключение: request@octopus-online.ru</a>
            </div><!--inside-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12 animated bounceInLeft">
            <div class="inside left">
              <div class="images"><img src="assets/images/address-light.svg" alt="address"></div>
              <h4>Адрес</h4>
              <span>г. Курск, пр-кт Анатолия Дериглазова, дом 83 </span>
            </div><!--inside-->
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 animated bounceInRight">
            <!--<div class="inside right">
              <div class="images"><img src="assets/images/like-light.svg" alt="like"></div>
              <h4>Follow Us</h4>
              <ul class="social-icon">
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                <li><a href="#"><i class="fa fa-youtube"></i></a></li>
              </ul>&lt;!&ndash;social-icon&ndash;&gt;
            </div>&lt;!&ndash;inside&ndash;&gt;-->
          </div>
        </div>
      </div><!--info-block-contact-->
    </div>
  </div>
</section>

